<template>
  <div class="view-container">
  <PageHeader title="تنظیمات" infoTitle="راهنمای تنظیمات" :infoLearnUrl="infoLearnUrl">
    <template #info>
      <p>
        با استفاده از تب تنظیمات عمومی امکان دسترسی به تنظیمات زبان، تم نمایش، تنظیمات مالی، اعلان ها وجود دارد. همچنین در این قسمت امکان مشاهده شرایط استفاده و حریم خصوصی نیز هست.
      </p>
      <p>
        با استفاده از تب تنظیمات ارسال پیامک امکان انتخاب پنل مد نظر و تنظیمات پنل وجود دارد.
      </p>
    </template>
  </PageHeader>
    <!-- تب‌های تنظیمات -->
    <div class="settings-tabs">
      <div></div>
      <button class="tab-button" :class="{ active: activeTab === 'general-settings' }"
        @click="activeTab = 'general-settings'">
        تنظیمات عمومی
      </button>
      <button class="tab-button" :class="{ active: activeTab === 'sms-settings' }" @click="activeTab = 'sms-settings'">
        تنظیمات ارسال پیامک
      </button>
      <button class="tab-button" :class="{ active: activeTab === 'print-settings' }"
        @click="activeTab = 'print-settings'">
        تنظیمات سامانه مطب
      </button>
    </div>

    <!-- محتوای تب تنظیمات عمومی -->
    <div v-if="activeTab === 'general-settings'" class="tab-content">
      <div class="settings-container">
        <div class="sub-header">
          <div class="header-actions">
            <BaseButton title="بازنشانی" variant="cancel" @click="resetGeneralSettings" />
            <BaseButton
              :title="isSaving ? '...در حال ذخیره' : 'ذخیره تنظیمات عمومی'"
              variant="primary"
              type="submit"
              :disabled="isSaving"
              @click="saveGeneralSettings"
            />
          </div>
          <h2 class="page-title">تنظیمات عمومی</h2>
        </div>

        <hr class="divider-line divider-line--lg" />

        <form @submit.prevent="saveGeneralSettings" class="settings-form">
          <div class="form-section rtl">
            <h3>تنظیمات پایه</h3>
            <div class="cache-controls"
              style="margin: 8px 0 16px; display:flex; align-items:center; gap:8px; flex-wrap:wrap;">
              <BaseButton title="پاک کردن کش" variant="cancel" @click="clearSettingsCache" />
              <BaseButton
                :title="isLoading ? 'در حال بروزرسانی...' : 'بروزرسانی از سرور'"
                variant="outline"
                :disabled="isLoading"
                @click="forceRefreshSettings"
              />
              <small class="text-muted" style="margin-left:8px;">
                آخرین بروزرسانی: {{ lastUpdateTime }}
                <span v-if="hasValidCache()" class="cache-badge">📦 از کش</span>
                <span v-else class="cache-badge">🔄 از سرور</span>
              </small>
            </div>
            <div class="form-grid">
              <div class="form-group">
                <label for="language">زبان سیستم</label>
                <select id="language" v-model="generalSettings.language">
                  <option value=1>فارسی</option>
                  <option value=2>عربی</option>
                  <option value=3>English</option>
                </select>
              </div>
              <div class="form-group">
                <label for="tax-percent">درصد مالیات</label>
                <input id="tax-percent" type="number" min="0" max="100" step="0.1"
                  v-model.number="generalSettings.taxPercent" placeholder="مثلاً 9" />
              </div>
              <div class="form-group">
                <label for="timezone">منطقه زمانی</label>
                <select id="timezone" v-model="generalSettings.timezone">
                  <option value=1>Asia/Tehran (GMT+3:30)</option>
                  <option value=2>UTC</option>
                </select>
              </div>
              <div class="form-group">
                <label for="date-format">فرمت تاریخ</label>
                <select id="date-format" v-model="generalSettings.dateFormat">
                  <option value=1>jYYYY/jMM/jDD</option>
                  <option value=2>YYYY-MM-DD</option>
                </select>
              </div>
              <div class="form-group">
                <label for="default-theme">تم پیش فرض</label>
                <select id="default-theme" v-model="generalSettings.defaultTheme">
                  <option value=1>سفید</option>
                  <option value=2>مشکی</option>
                  <option value=3>طوسی</option>
                  <option value=4>کرم</option>
                </select>
              </div>
              <div class="form-group">
                <label for="default-page">صفحه پیش فرض</label>
                <select id="default-page" v-model="generalSettings.defaultPage">
                  <option value=1>بیماران</option>
                  <option value=2>ثبت نوبت</option>
                  <option value=3>لیست نوبت‌ها</option>
                  <option value=4>ثبت قبض</option>
                  <option value=5>انبار</option>
                  <option value=6>گزارش ها</option>
                </select>
              </div>
              <!-- Removed modianReceiptFormChange and automaticPatientNumber from General Settings per request -->
            </div>
          </div>

          <div class="form-section">
            <h3>تنظیمات مالی</h3>
            <div class="form-grid">
                <div class="form-group">
                <label for="vat-percent">درصد ارزش افزوده</label>
                  <input id="vat-percent" type="number" min="0" max="100" step="1" inputmode="numeric" pattern="[0-9]*" v-model.number="generalSettings.vatPercent" @input="onVatInput" placeholder="مثلاً 9" class="narrow-input" />
              </div>
            </div>
          </div>

          <div class="form-section">
            <h3>اعلان‌ها</h3>
            <div class="checkbox-group">
              <label class="checkbox-label">
                <input type="checkbox" v-model="generalSettings.enableNotifications" />
                فعال‌سازی اعلان‌ها
              </label>
            </div>
          </div>

          <div class="form-section">
            <h3>شرایط استفاده و حریم خصوصی</h3>
            <button type="button" class="btn btn-secondary" @click="openClinicPlatformContractModal">
              قرارداد سامانه مطب
            </button>
            <button type="button" class="btn btn-secondary"
              @click="openLink('https://www.sinapardazesh.ir/support-contract/')">قرارداد پشتیبانی</button>
            <button type="button" class="btn btn-secondary"
              @click="openLink('https://www.sinapardazesh.ir/terms-of-service/')">شرایط استفاده از خدمات</button>
            <button type="button" class="btn btn-secondary"
              @click="openLink('https://www.sinapardazesh.ir/privacy-policy/')">سیاست حفظ حریم خصوصی</button>
            <button type="button" class="btn btn-secondary"
              @click="openLink('https://www.sinapardazesh.ir/refund_returns/')">سیاست مرجوعی و عودت کالا</button>
            <button type="button" class="btn btn-secondary"
              @click="openLink('https://www.sinapardazesh.ir/%d8%b3%d9%88%d8%a7%d9%84%d8%a7%d8%aa-%d9%85%d8%aa%d8%af%d8%a7%d9%88%d9%84/')">سوالات
              متداول</button>
          </div>


        </form>
      </div>
    </div>

    <!-- محتوای تب تنظیمات چاپ قبض -->
    <div v-if="activeTab === 'print-settings'" class="tab-content">
      <div class="settings-container">
        <div class="sub-header">
          <div class="header-actions">
            <BaseButton title="بازنشانی" variant="cancel" @click="resetPrintSettings" />
            <BaseButton title="ذخیره تنظیمات" variant="primary" type="submit" @click="savePrintSettings" />
          </div>

          <div class="title-group">
            <h2 class="page-title">تنظیمات سامانه مطب</h2>
          </div>
        </div>

        <hr class="divider-line divider-line--lg" />

        <form @submit.prevent="savePrintSettings" class="settings-form">
          <div class="form-section">
            <h3>تنظیمات عمومی سامانه مطب</h3>
            <div class="form-grid">
              <div class="form-row">
                <div class="form-group select-narrow">
                  <label for="default-currency">واحد پول پیش‌فرض</label>
                  <select id="default-currency" dir="rtl" v-model="printSettings.defaultCurrency">
                    <option value="IRR">تومان</option>
                    <option value="USD">دلار</option>
                  </select>
                </div>
                <div class="form-group select-narrow">
                  <label for="default-insurance">بیمه پیش فرض</label>
                  <select id="default-insurance" dir="rtl" v-model="printSettings.defaultInsurance">
                    <option value=1>آزاد</option>
                    <option value=2>تامین اجتماعی</option>
                    <option value=3>نیروهای مسلح</option>
                    <option value=4>بیمه سلامت</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-spaced narrow-checkbox online-booking">
                <label for="online-booking-enabled">رزرو آنلاین</label>
                <label class="checkbox-label">
                  <input id="online-booking-enabled" type="checkbox" v-model="printSettings.onlineBooking" />
                  فعال
                </label>
              </div>
              <!-- New checkbox: sync/add patient info using national ID API -->
              <div class="form-group form-group-margin-top">
                <label for="sync-patient-natapi">ثبت اطلاعات بیمار با API کد ملی</label>
                <label class="checkbox-label">
                  <input id="sync-patient-natapi" type="checkbox" v-model="printSettings.syncPatientByNationalApi" />
                  فعال
                </label>
              </div>
              <div class="form-group form-group-margin-top">
                <label for="modian-receipt-change">تغییر فرم قبض جهت سامانه مودیان</label>
                <label class="checkbox-label">
                  <input id="modian-receipt-change" type="checkbox" v-model="printSettings.modianReceiptFormChange" />
                  فعال
                </label>
              </div>
              <div class="form-group form-group-margin-top">
                <label for="automatic-patient-number">شماره پرونده اتوماتیک</label>
                <label class="checkbox-label">
                  <input id="automatic-patient-number" type="checkbox" v-model="printSettings.automaticPatientNumber" />
                  فعال
                </label>
              </div>
            </div>
          </div>

          <!-- تنظیمات نوبت دهی -->
          <div class="form-section rtl">
            <h3>تنظیمات نوبت دهی</h3>
            <div class="form-grid">
              <div class="form-group">
                <div class="radio-group">
                  <label class="checkbox-label radio-label">
                    <input type="radio" name="appointment-mode" value="table" v-model="printSettings.appointmentMode" />
                    <span class="radio-text">جدول نوبت دهی</span>
                  </label>
                  <label class="checkbox-label radio-label">
                    <input type="radio" name="appointment-mode" value="single" v-model="printSettings.appointmentMode" />
                    <span class="radio-text">نوبت دهی تکی</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="form-section">
            <h3>تنظیمات کلی چاپ قبض</h3>
            <div class="form-grid">
              <div class="form-group">
                <label for="clinic-name">نام مطب</label>
                <input id="clinic-name" type="text" v-model="printSettings.clinicName"
                  placeholder="نام مطب خود را وارد کنید" />
              </div>
              <div class="form-group">
                <label for="clinic-address">آدرس مطب</label>
                <input id="clinic-address" type="text" v-model="printSettings.clinicAddress"
                  placeholder="آدرس مطب را وارد کنید" />
              </div>
              <div class="form-group">
                <label for="clinic-phone">شماره تلفن</label>
                <input id="clinic-phone" type="text" v-model="printSettings.clinicPhone" placeholder="شماره تلفن مطب" />
              </div>
              <div class="form-group">
                <label for="clinic-license">شماره پروانه</label>
                <input id="clinic-license" type="text" v-model="printSettings.clinicLicense"
                  placeholder="شماره پروانه مطب" />
              </div>
              <div class="form-group">
                <label for="print-type">نوع چاپ</label>
                <select id="print-type" v-model="printSettings.printType">
                  <option value=0>شیوه دلخواه</option>
                  <option value=1>مطب نوع 1</option>
                  <option value=2>مطب نوع 2</option>
                  <option value=3>مطب (فیش پرینت1)</option>
                  <option value=4>مطب (فیش پرینت2)</option>
                  <option value=5>مطب (فیش پرینت3)</option>
                  <option value=6>مطب (فیش پرینت4)</option>
                  <option value=7>مطب (فیش پرینت5)</option>
                  <option value=8>مطب (فیش پرینت6)</option>
                </select>
              </div>
            </div>
          </div>

          <div class="form-section">
            <h3>تنظیمات فونت و چاپ قبض</h3>
            <div class="form-grid">
              <div class="form-group">
                <label for="font-size">اندازه فونت</label>
                <select id="font-size" v-model="printSettings.fontSize">
                  <option value=0>کوچک</option>
                  <option value=1>متوسط</option>
                  <option value=2>بزرگ</option>
                </select>
              </div>
              <div class="form-group">
                <label for="paper-size">اندازه کاغذ</label>
                <select id="paper-size" v-model="printSettings.paperSize">
                  <option value=0>حرارتی</option>
                  <option value=1>A4</option>
                  <option value=2>A5</option>
                </select>
              </div>
              <div class="form-group">
                <label for="print-margin">حاشیه چاپ</label>
                <input id="print-margin" type="number" v-model="printSettings.printMargin"
                  placeholder="حاشیه به میلیمتر" />
              </div>
            </div>
          </div>

          <div class="form-section">
            <h3>تنظیمات محتوای قبض</h3>
            <div class="checkbox-group checkbox-right">
              <label class="checkbox-label">
                <input type="checkbox" v-model="printSettings.showLogo" />
                نمایش لوگو
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="printSettings.showDate" />
                نمایش تاریخ
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="printSettings.showTime" />
                نمایش ساعت
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="printSettings.showReceiptNumber" />
                نمایش شماره قبض
              </label>
            </div>
          </div>

          <div class="form-section">
            <h3>متن‌ها و اطلاعات تکمیلی قبض</h3>
            <div class="form-grid">
              <div class="form-group">
                <label for="header-text">متن سر صفحه</label>
                <input id="header-text" type="text" v-model="printSettings.headerText"
                  placeholder="متن سرصفحه را وارد کنید" />
              </div>
              <div class="form-group">
                <label for="footer-text">متن پا صفحه</label>
                <input id="footer-text" type="text" v-model="printSettings.footerText"
                  placeholder="متن پاصفحه را وارد کنید" />
              </div>
              <div class="form-group">
                <label for="row-title">عنوان ردیف ها</label>
                <input id="row-title" type="text" v-model="printSettings.rowTitle"
                  placeholder="مثلاً ردیف، شرح، مبلغ" />
              </div>
              <div class="form-group">
                <label for="slogan-text">متن شعار</label>
                <input id="slogan-text" type="text" v-model="printSettings.sloganText"
                  placeholder="شعار یا جمله تبلیغاتی" />
              </div>
              <div class="form-group">
                <label for="specialty-extra">تکمیلی تخصص</label>
                <input id="specialty-extra" type="text" v-model="printSettings.specialtyExtra"
                  placeholder="توضیح تکمیلی تخصص" />
              </div>
              <div class="form-group">
                <label for="instagram">اینستاگرام</label>
                <input id="instagram" type="text" v-model="printSettings.instagram"
                  placeholder="شناسه یا لینک اینستاگرام" />
              </div>
              <div class="form-group">
                <label for="telegram">تلگرام</label>
                <input id="telegram" type="text" v-model="printSettings.telegram" placeholder="شناسه یا لینک تلگرام" />
              </div>
              <div class="form-group">
                <label for="whatsapp">واتساپ</label>
                <input id="whatsapp" type="text" v-model="printSettings.whatsapp" placeholder="شماره یا لینک واتساپ" />
              </div>
            </div>
          </div>

          <div class="form-section">
            <h3>تنظیمات ارسال خودکار پیامک</h3>
            <div class="checkbox-group">
              <label class="checkbox-label">
                <input type="checkbox" v-model="printSettings.autoSendAppointment" />
                ارسال خودکار پیامک برای نوبت‌های جدید
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="printSettings.autoSendReminder" />
                ارسال خودکار یادآوری نوبت
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="printSettings.autoSendReceipt" />
                ارسال خودکار پیامک پس از ثبت قبض
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="printSettings.autoSendAfterSettlement" />
                ارسال خودکار پیامک پس از تسویه قبض
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="printSettings.autoSendOnPatientRecord" />
                ارسال خودکار پیامک ثبت پرونده
              </label>
              <div class="checkbox-label">
                <input type="checkbox" v-model="printSettings.autoSendReceptionList" />
                <span>ارسال خودکار پیامک برای لیست پذیرش برای</span>
                <input type="number" min="1" v-model.number="printSettings.receptionListDaysAfter" />
                <span>روز بعد</span>
              </div>
            </div>
          </div>

          <div class="form-section">
            <h3>قالب پیامک‌ها</h3>
            <div class="form-group">
              <label for="appointment-template">قالب پیامک نوبت</label>
              <textarea id="appointment-template" v-model="defaultPrintSettings.appointmentTemplate"
                placeholder="سلام {نام}، نوبت شما برای {تاریخ} در ساعت {ساعت} ثبت شد. شماره نوبت: {شماره_نوبت}"
                rows="3"></textarea>
            </div>
            <div class="form-group">
              <label for="reminder-template">قالب پیامک یادآوری</label>
              <textarea id="reminder-template" v-model="defaultPrintSettings.reminderTemplate"
                placeholder="یادآوری: نوبت شما فردا در ساعت {ساعت} است. لطفاً 15 دقیقه زودتر حضور یابید."
                rows="3"></textarea>
            </div>
            <div class="form-group">
              <label for="receipt-template">قالب پیامک قبض</label>
              <textarea id="receipt-template" v-model="defaultPrintSettings.receiptTemplate"
                placeholder="قبض شما به مبلغ {مبلغ} تومان ثبت شد. شماره قبض: {شماره_قبض}" rows="3"></textarea>
            </div>
          </div>

          <div class="form-section">
            <h3>حذف اطلاعات</h3>
            <div class="delete-buttons-container">
              <button type="button" class="btn btn-danger" @click="onDeleteBills">
                حذف قبوض
              </button>
              <button type="button" class="btn btn-danger" @click="onDeletePatients">
                حذف بیماران
              </button>
              <button type="button" class="btn btn-danger" @click="openAppointmentDeleteModal">
                حذف جداول نوبت
              </button>
            </div>
          </div>

          <!-- Modal: delete appointment tables -->
          <div v-if="showDeleteAppointmentModal" class="modal-overlay">
            <div class="modal-box" role="dialog" aria-modal="true" aria-labelledby="delete-appt-title">
              <ModalHeader>
                <template #default>
                  <h3 id="delete-appt-title" class="modal-title">حذف جداول نوبت</h3>
                </template>
                <template #actions>
                  <button type="button" class="modal-close" @click="closeAppointmentDeleteModal" aria-label="بستن">×</button>
                </template>
              </ModalHeader>

              <div class="modal-warning">هشدار: این عمل غیرقابل بازگشت است. لطفاً بازه زمانی را دقیق انتخاب کنید.</div>

              <div class="modal-body">
                <div class="modal-grid">
                  <div class="form-group p-date">
                    <label for="appt-from">از تاریخ</label>
                    <DatePicker
                      v-model="appointmentFromDate"
                      format="YYYY-MM-DD"
                      display-format="YYYY-MM-DD"
                      :editable="true"
                      :clearable="true"
                      placeholder="انتخاب تاریخ"
                      input-class="form-input"
                    />
                  </div>

                  <div class="form-group p-date">
                    <label for="appt-to">تا تاریخ</label>
                    <DatePicker
                      v-model="appointmentToDate"
                      format="YYYY-MM-DD"
                      display-format="YYYY-MM-DD"
                      :editable="true"
                      :clearable="true"
                      placeholder="انتخاب تاریخ"
                      input-class="form-input"
                    />
                  </div>
                </div>
              </div>

              <div class="modal-actions">
                <BaseButton title="انصراف" variant="cancel" @click="closeAppointmentDeleteModal" />
                <button type="button" class="btn btn-danger btn-delete-confirm" @click="onDeleteAppointmentTables">حذف نهایی</button>
              </div>
            </div>
          </div>


        </form>
      </div>
    </div>

    <!-- محتوای تب تنظیمات پیامک -->
    <div v-if="activeTab === 'sms-settings'" class="tab-content">
      <div class="settings-container">
        <div class="sub-header">
          <div class="header-actions">
                  <BaseButton title="بازنشانی" variant="cancel" @click="resetSmsSettings" />
                  <BaseButton title="ذخیره تنظیمات" variant="primary" type="submit" @click="saveSmsSettings" />
          </div>
          <h2 class="page-title">تنظیمات ارسال پیامک</h2>
        </div>

        <hr class="divider-line divider-line--lg" />

        <form @submit.prevent="saveSmsSettings" class="settings-form">
          <div class="form-section">
            <h3>تنظیمات سرویس پیامک</h3>
            <div class="form-grid">
              <div class="form-group">
                <label for="sms-provider">ارائه دهنده سرویس</label>
                <select id="sms-provider" v-model="smsSettings.provider">
                  <option value=0>انتخاب کنید</option>
                  <option value=1>پنل پیامک سیناپردازش 1</option>
                  <option value=2>پنل پیامک سیناپردازش 2</option>
                </select>
              </div>
              <div class="form-group">
                <label for="username">نام کاربری</label>
                <input id="username" type="text" v-model="smsSettings.smsUsername"
                  placeholder="نام کاربری سرویس پیامک" />
              </div>
              <div class="form-group">
                <label for="password">کلمه عبور</label>
                <input id="password" type="password" v-model="smsSettings.smsPassword"
                  placeholder="کلمه عبور سرویس پیامک" />
              </div>
              <div class="form-group">
                <label for="sender-number">شماره فرستنده</label>
                <input id="sender-number" type="text" v-model="smsSettings.senderNumber"
                  placeholder="شماره فرستنده پیامک" />
              </div>
            </div>
          </div>


        </form>
      </div>
    </div>

    <!-- Modal: قرارداد سامانه مطب -->
    <div v-if="showClinicPlatformContractModal" class="modal-overlay">
      <div class="modal-box contract-modal" role="dialog" aria-modal="true" aria-labelledby="clinic-platform-contract-title">
        <ModalHeader>
          <template #default>
            <h3 id="clinic-platform-contract-title" class="modal-title">قرارداد سامانه مطب</h3>
          </template>
          <template #actions>
            <button type="button" class="modal-close" @click="closeClinicPlatformContractModal" aria-label="بستن">×</button>
          </template>
        </ModalHeader>

        <div class="modal-body">
          <div class="contract-text" dir="rtl">
            <pre class="contract-pre">{{ clinicPlatformContractText }}</pre>
          </div>

          <label class="checkbox-label contract-accept">
            <input type="checkbox" v-model="clinicPlatformContractAccepted" />
            شرایط فوق را میپذیریم
          </label>
        </div>

        <div class="modal-actions">
          <BaseButton title="انصراف" variant="cancel" @click="closeClinicPlatformContractModal" />
          <BaseButton
            title="ثبت"
            variant="primary"
            type="button"
            :disabled="!clinicPlatformContractAccepted"
            @click="submitClinicPlatformContract"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader.vue';
import { defineOptions } from 'vue'
defineOptions({
  name: 'AppSettings'
})
import { useSettingStore } from "@/stores/clinic/setting";
import { storeToRefs } from "pinia";
import { ref, reactive, onMounted, watch } from "vue";
import { useRouter, useRoute } from 'vue-router';
import { useToast } from "vue-toastification";
import ArrowRightSvg from '@/components/svgs/ArrowRightSvg.vue'
import ModalHeader from '@/components/ModalHeader.vue'
import BaseButton from '@/components/UiCompunents/BaseButton.vue'
import { useConfirm } from '@/stores/composables.js'
import DatePicker from 'vue3-persian-datetime-picker'

// --- State ---
const route = useRoute();
const router = useRouter();
const toast = useToast();
const activeTab = ref(
  route.query.tab === 'general' ? 'general-settings' :
  route.query.tab === 'sms' ? 'sms-settings' : 'print-settings'
);

// Keep URL query param in sync with tab selection so parent layout can react to it
watch(activeTab, (val) => {
  let tabQuery = 'print';
  if (val === 'general-settings') tabQuery = 'general';
  else if (val === 'sms-settings') tabQuery = 'sms';
  // Use replace so we don't keep pushing history entries when user toggles tabs
  try {
    router.replace({ path: route.path, query: { ...route.query, tab: tabQuery } });
  } catch (e) {
    // ignore errors in router during development or SSR
    console.debug('Could not replace route query for activeTab change', e);
  }
}, { immediate: true });

// keep activeTab in sync with URL (useful for navigating via links/back/forward)
watch(() => route.query.tab, (val) => {
  if (val === 'general') activeTab.value = 'general-settings';
  else if (val === 'sms') activeTab.value = 'sms-settings';
  else activeTab.value = 'print-settings';
});
const settingStore = useSettingStore();
const { settingEntity } = storeToRefs(settingStore);
const { fetchSetting, saveOrUpdateSetting, parseSettings, hasValidCache, clearCache } = settingStore;

const isSaving = ref(false);
const isLoading = ref(false);
const lastUpdateTime = ref(null);

// تنظیمات پیش‌فرض
const defaultPrintSettings = {
  clinicName: "",
  clinicAddress: "",
  clinicPhone: "",
  clinicLicense: "",
  onlineBooking: false,
  // whether to sync/add patient info via national-ID API
  syncPatientByNationalApi: false,
  defaultCurrency: "IRR",
  defaultInsurance: 1,
  fontSize: 1,
  paperSize: 1,
  printMargin: 10,
  printType: 1,
  showLogo: true,
  showDate: true,
  showTime: true,
  showReceiptNumber: true,
  headerText: "",
  footerText: "",
  rowTitle: "",
  sloganText: "",
  specialtyExtra: "",
  instagram: "",
  telegram: "",
  whatsapp: "",
  autoSendAppointment: false,
  autoSendReminder: false,
  autoSendReceipt: false,
  autoSendAfterSettlement: false,
  autoSendOnPatientRecord: false,
  autoSendReceptionList: false,
  automaticPatientNumber: true,
  modianReceiptFormChange: false,
  receptionListDaysAfter: 1,
  // new appointment mode setting: 'table' (جدول نوبت دهی) or 'single' (نوبت دهی تکی)
  appointmentMode: 'table',
  appointmentTemplate: "",
  reminderTemplate: "",
  receiptTemplate: ""
};

const defaultGeneralSettings = {
  dateFormat: 1,
  timezone: 1,
  taxPercent: 0,
  vatPercent: 0,
  language: 1,
  enableNotifications: true,
  defaultTheme: 1,
  defaultPage: 1
};

const defaultSmsSettings = {
  provider: 1,
  smsUsername: "",
  smsPassword: "",
  senderNumber: ""
};

// reactive settings
const printSettings = reactive({ ...defaultPrintSettings });
const generalSettings = reactive({ ...defaultGeneralSettings });
const smsSettings = reactive({ ...defaultSmsSettings });
// keep a minimal passwordData object for backward-compat (some builds/templates
// may still reference it transiently). Having it avoids ESLint no-undef errors
// when the change-password section was removed from the template.
const passwordData = reactive({
  currentPassword: '',
  newPassword: '',
  confirmPassword: ''
});

// modal state for deleting appointment tables
const showDeleteAppointmentModal = ref(false);
const appointmentFromDate = ref('');
const appointmentToDate = ref('');

// modal state: clinic platform contract
const showClinicPlatformContractModal = ref(false);
const clinicPlatformContractAccepted = ref(false);

const clinicPlatformContractText = `بسمه تعالی
توافق‌نامه استفاده از سامانه مطب تحت وب سیناپردازش

این توافق‌نامه فی‌مابین شرکت/مجموعه «سیناپردازش» (که از این پس «ارائه‌دهنده» نامیده می‌شود) و کاربر سامانه (پزشک، مدیر مطب یا نماینده قانونی ایشان که از این پس «کاربر» نامیده می‌شود) منعقد می‌گردد.

ثبت‌نام در سامانه، ایجاد حساب کاربری و یا کلیک بر روی گزینه «می‌پذیرم» به منزله مطالعه دقیق مفاد این توافق‌نامه و قبول کلیه شرایط آن بوده و این پذیرش، از نظر قانونی در حکم امضای الکترونیکی و لازم‌الاجرا است.

ماده ۱- موضوع قرارداد

موضوع این توافق‌نامه عبارت است از اعطای حق استفاده غیرانحصاری و محدود از «سامانه مطب تحت وب سیناپردازش» شامل امکانات نرم‌افزاری مرتبط با مدیریت مطب، نوبت‌دهی، پرونده الکترونیک بیماران، امور مالی، گزارش‌گیری و سایر خدمات تعریف‌شده در سامانه.

ماده ۲- مدت قرارداد

مدت استفاده از سامانه بر اساس پلن انتخابی کاربر (ماهانه/سالانه یا سایر طرح‌ها) بوده و از تاریخ فعال‌سازی حساب کاربری آغاز می‌گردد. تمدید استفاده منوط به پرداخت هزینه اشتراک طبق تعرفه‌های اعلامی در سامانه خواهد بود.

ماده ۳- تعهدات ارائه‌دهنده

ارائه‌دهنده متعهد می‌گردد:

دسترسی کاربر به سامانه را در طول مدت اشتراک فعال نگه دارد، مگر در موارد:

تعمیرات و به‌روزرسانی‌های فنی

فورس ماژور

نقض تعهدات از سوی کاربر

از اطلاعات ثبت‌شده در سامانه با استفاده از تدابیر امنیتی متعارف محافظت نماید.

نسخه پشتیبان (Backup) متعارف از اطلاعات را مطابق سیاست‌های داخلی خود تهیه نماید.

در حد متعارف پشتیبانی فنی را از طریق روش‌های اعلام‌شده در سامانه ارائه دهد.

ماده ۴- تعهدات کاربر

کاربر متعهد می‌گردد:

اطلاعات صحیح، کامل و واقعی در سامانه ثبت نماید.

از نام کاربری و رمز عبور خود محافظت نموده و مسئولیت کلیه فعالیت‌های انجام‌شده با حساب کاربری خود را بپذیرد.

از سامانه صرفاً در چارچوب قوانین جمهوری اسلامی ایران و مقررات مرتبط با حوزه پزشکی استفاده نماید.

از ثبت اطلاعات غیرقانونی، خلاف اخلاق حرفه‌ای، ناقض حریم خصوصی بیماران یا مغایر با مقررات نظام پزشکی خودداری نماید.

مسئولیت کامل صحت اطلاعات پزشکی، مالی و اداری ثبت‌شده در سامانه را بر عهده بگیرد.

ماده ۵- مالکیت فکری

کلیه حقوق مادی و معنوی سامانه، کدها، طراحی، ساختار و محتوا متعلق به ارائه‌دهنده می‌باشد.

کاربر صرفاً حق استفاده از سامانه را داشته و مجاز به کپی‌برداری، مهندسی معکوس، واگذاری، فروش مجدد یا بهره‌برداری خارج از چارچوب این قرارداد نمی‌باشد.

ماده ۶- محرمانگی اطلاعات

اطلاعات بیماران ثبت‌شده در سامانه متعلق به کاربر بوده و ارائه‌دهنده صرفاً در نقش پردازشگر داده عمل می‌نماید.

ارائه‌دهنده متعهد است اطلاعات کاربران و بیماران را بدون مجوز قانونی یا رضایت کاربر افشا ننماید، مگر در موارد الزام قانونی توسط مراجع ذی‌صلاح.

کاربر نیز موظف به رعایت محرمانگی اطلاعات دسترسی به سامانه می‌باشد.

ماده ۷- مسئولیت‌ها و محدودیت‌ها

ارائه‌دهنده مسئولیتی در قبال قطعی اینترنت، اختلالات زیرساختی خارج از کنترل، حملات سایبری گسترده یا حوادث غیرمترقبه ندارد.

مسئولیت استفاده نادرست از سامانه، خطا در ورود اطلاعات یا تصمیمات پزشکی اتخاذشده بر اساس اطلاعات ثبت‌شده، صرفاً بر عهده کاربر است.

ارائه‌دهنده تضمین نمی‌کند که سامانه در همه زمان‌ها بدون وقفه یا خطا باشد، لکن متعهد به تلاش متعارف جهت رفع مشکلات خواهد بود.

ماده ۸- هزینه‌ها و پرداخت

استفاده از سامانه منوط به پرداخت هزینه اشتراک مطابق تعرفه‌های اعلامی در سایت/سامانه می‌باشد.

در صورت عدم پرداخت در موعد مقرر، ارائه‌دهنده مجاز به تعلیق یا قطع دسترسی کاربر خواهد بود.

مبالغ پرداختی، مگر در موارد خاص مصرح در سامانه، غیرقابل استرداد می‌باشد.

ماده ۹- فسخ و تعلیق

در صورت نقض مفاد این توافق‌نامه توسط کاربر، ارائه‌دهنده مجاز به تعلیق یا فسخ دسترسی خواهد بود.

کاربر می‌تواند در هر زمان درخواست لغو حساب کاربری نماید، لکن این امر موجب استرداد مبالغ پرداختی نخواهد شد مگر طبق شرایط اعلامی در سامانه.

ماده ۱۰- فورس ماژور

در صورت بروز حوادث خارج از اراده طرفین از جمله بلایای طبیعی، جنگ، اختلالات گسترده اینترنت یا دستورات حاکمیتی، اجرای تعهدات تا زمان رفع مانع به حالت تعلیق درمی‌آید و مسئولیتی متوجه ارائه‌دهنده نخواهد بود.

ماده ۱۱- قانون حاکم و حل اختلاف

این توافق‌نامه تابع قوانین جمهوری اسلامی ایران است و در صورت بروز اختلاف، موضوع ابتدا از طریق مذاکره حل‌وفصل خواهد شد و در صورت عدم توافق، مراجع صالح قضایی محل اقامت ارائه‌دهنده صالح به رسیدگی خواهند بود.

ماده ۱۲- پذیرش الکترونیکی

کاربر با ثبت‌نام در سامانه و کلیک بر گزینه «می‌پذیرم» اعلام می‌نماید که کلیه مفاد این توافق‌نامه را مطالعه نموده، از آن آگاه است و آن را به طور کامل و بدون قید و شرط می‌پذیرد. این پذیرش از نظر قانونی در حکم امضای معتبر و لازم‌الاجرا می‌باشد.`;

// --- Methods ---
async function saveGeneralSettings() {
  // coerce VAT percent to integer (remove decimals) and validate
  if (generalSettings.vatPercent !== null && generalSettings.vatPercent !== undefined && generalSettings.vatPercent !== '') {
    generalSettings.vatPercent = Math.round(Number(generalSettings.vatPercent));
  }
  // validate VAT percent before saving
  if (isNaN(generalSettings.vatPercent) || generalSettings.vatPercent < 0 || generalSettings.vatPercent > 100) {
    toast.error('مقدار درصد مالیات بر ارزش افزوده معتبر نیست (باید بین 0 تا 100 باشد)');
    return;
  }
  await saveSettings('general');
}

async function savePrintSettings() {
  await saveSettings('pation');
}

async function saveSmsSettings() {
  await saveSettings('sms');
}

async function saveSettings(type) {
  isSaving.value = true;

  try {
    const settingsData = {
      printSettings,
      generalSettings,
      smsSettings
    };
    const success = await saveOrUpdateSetting(settingsData);

    if (success) {
      toast.success(`تنظیمات ${getSettingTypeName(type)} با موفقیت ذخیره شد`);
      lastUpdateTime.value = new Date().toLocaleTimeString('fa-IR');
    }
  } catch (error) {
    toast.error('خطا در ذخیره تنظیمات');
    console.error('Error saving settings:', error);
  } finally {
    isSaving.value = false;
  }
}

function onVatInput(e) {
  // Coerce input to integer-only values; remove any decimal and non-digit characters
  const raw = e.target.value + '';
  if (!raw) {
    // allow empty input
    generalSettings.vatPercent = null;
    return;
  }
  // Remove non-digit characters
  const cleaned = raw.replace(/[^0-9]/g, '');
  if (cleaned === '') {
    generalSettings.vatPercent = null;
    e.target.value = '';
    return;
  }
  let num = parseInt(cleaned, 10);
  if (isNaN(num)) {
    generalSettings.vatPercent = null;
    e.target.value = '';
    return;
  }
  // clamp to valid percent range
  if (num < 0) num = 0;
  if (num > 100) num = 100;
  generalSettings.vatPercent = num;
  e.target.value = String(num);
}

function getSettingTypeName(type) {
  const names = {
    'general': 'عمومی',
    'pation': 'مطب',
    'sms': 'پیامک'
  };
  return names[type] || '';
}

async function forceRefreshSettings() {
  isLoading.value = true;

  try {
    await fetchSetting(true); // force refresh
    loadSettings();
    toast.success('تنظیمات با آخرین نسخه سرور بروزرسانی شد');
    lastUpdateTime.value = new Date().toLocaleTimeString('fa-IR');
  } catch (error) {
    toast.error('خطا در بروزرسانی تنظیمات');
    console.error('Error refreshing settings:', error);
  } finally {
    isLoading.value = false;
  }
}

// 🔥 تابع جدید برای پاک کردن کش
function clearSettingsCache() {
  clearCache();
  toast.info('کش تنظیمات پاک شد');
}

function resetGeneralSettings() {
  Object.assign(generalSettings, defaultGeneralSettings);
}

function resetPrintSettings() {
  Object.assign(printSettings, defaultPrintSettings);
}

function resetSmsSettings() {
  Object.assign(smsSettings, defaultSmsSettings);
}

function loadSettings() {
  const parsedSettings = parseSettings(settingEntity.value);
  if (parsedSettings) {
    if (parsedSettings.printSettings) {
      Object.assign(printSettings, parsedSettings.printSettings);
    }
    if (parsedSettings.generalSettings) {
      Object.assign(generalSettings, parsedSettings.generalSettings);
      // اگر بک‌اند مقدار automaticPatientNumber را ارسال نکرده باشد، مقدار پیش‌فرض را نگه‌دار
      if (typeof parsedSettings.printSettings.automaticPatientNumber === 'undefined') {
        printSettings.automaticPatientNumber = defaultPrintSettings.automaticPatientNumber;
      }
    }
    if (parsedSettings.smsSettings) {
      Object.assign(smsSettings, parsedSettings.smsSettings);
    }
  }

  // نمایش وضعیت کش
  console.log('📦 Cache status:', hasValidCache() ? 'Valid cache available' : 'No valid cache');
}

function openContractTextModal() {
  alert("باز کردن مدال متن قرارداد");
}

function openClinicPlatformContractModal() {
  clinicPlatformContractAccepted.value = false;
  showClinicPlatformContractModal.value = true;
}

function closeClinicPlatformContractModal() {
  showClinicPlatformContractModal.value = false;
  clinicPlatformContractAccepted.value = false;
}

function submitClinicPlatformContract() {
  if (!clinicPlatformContractAccepted.value) return;
  toast.success('قرارداد با موفقیت ثبت شد');
  closeClinicPlatformContractModal();
}

function openLink(url) {
  window.open(url, '_blank');
}

// Danger operations
async function onDeleteBills() {
  const { confirm } = useConfirm();
  const confirmed = await confirm("آیا از حذف تمامی قبوض اطمینان دارید؟ این عمل غیرقابل بازگشت است.");
  if (!confirmed) return;
  console.log("Deleting all bills by admin action from settings");
  alert("درخواست حذف قبوض ثبت شد (دموی رابط کاربری).");
}

async function onDeletePatients() {
  const { confirm } = useConfirm();
  const confirmed = await confirm("آیا از حذف تمامی بیماران اطمینان دارید؟ این عمل غیرقابل بازگشت است.");
  if (!confirmed) return;
  try {
    console.log("Deleting all patients by admin action from settings");
    alert("درخواست حذف بیماران ثبت شد (دموی رابط کاربری).");
  } catch (e) {
    console.error(e);
    alert("خطا در حذف بیماران");
  }
}

function openAppointmentDeleteModal() {
  showDeleteAppointmentModal.value = true;
}

function closeAppointmentDeleteModal() {
  showDeleteAppointmentModal.value = false;
  appointmentFromDate.value = '';
  appointmentToDate.value = '';
}

async function onDeleteAppointmentTables() {
  if (!appointmentFromDate.value || !appointmentToDate.value) {
    alert('لطفاً هر دو تاریخ را وارد کنید.');
    return;
  }
  if (appointmentFromDate.value > appointmentToDate.value) {
    alert('تاریخ "از" نمی‌تواند بعد از تاریخ "تا" باشد.');
    return;
  }

  const { confirm } = useConfirm();
  const confirmed = await confirm('آیا از حذف جداول نوبت در بازه انتخاب شده اطمینان دارید؟ این عمل غیرقابل بازگشت است.');
  if (!confirmed) return;

  // TODO: Replace this demo action with an actual API call if available
  console.log(`Deleting appointment tables from ${appointmentFromDate.value} to ${appointmentToDate.value}`);
  alert(`درخواست حذف جداول نوبت از ${appointmentFromDate.value} تا ${appointmentToDate.value} ثبت شد (دمو).`);
  closeAppointmentDeleteModal();
}
onMounted(async () => {
  isLoading.value = true;
  try {
    await fetchSetting();
    loadSettings();
    lastUpdateTime.value = new Date().toLocaleTimeString('fa-IR');
  } catch (error) {
    toast.error('خطا در بارگذاری تنظیمات');
    console.error('Error loading settings:', error);
  } finally {
    isLoading.value = false;
  }
});
</script>
<style scoped>
.view-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
}

/* قرارداد سامانه مطب */
.contract-modal {
  max-width: 860px;
  width: min(860px, 95vw);
}

.contract-text {
  border: 1px solid var(--text-color-secondary);
  background: var(--background-color-secondary);
  border-radius: 10px;
  padding: 12px;
  max-height: 55vh;
  overflow: auto;
}

.contract-pre {
  margin: 0;
  white-space: pre-wrap;
  line-height: 1.9;
  font-family: inherit;
  font-size: 14px;
  color: var(--text-color-primary);
}

.contract-accept {
  margin-top: 12px;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;
}

/* تب‌ها */
.settings-tabs {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 2px solid var(--text-color-secondary);
  flex-wrap: wrap;
}

.tab-button {
  padding: 12px 20px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-color-secondary);
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.tab-button:hover {
  color: var(--text-color-primary);
  background-color: var(--background-color-secondary);
}

.tab-button.active {
  color: var(--text-color-primary);
  border-bottom-color: var(--text-color-primary);
  background-color: var(--background-color-secondary);
}

.tab-content {
  background: var(--background-color);
  border: 1px solid var(--text-color-secondary);
  border-radius: 8px;
  padding: 25px;
}

.sub-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: var(--text-color-secondary);
  flex-direction: row-reverse;
}

.title-group {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
  /* place items to the right in RTL layout */
}

.narrow-input {
  width: 56px;
  max-width: 56px;
  min-width: 48px;
  padding: 6px 8px;
  text-align: right;
  box-sizing: border-box;
}

.clearCash-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 6px;
  background: var(--background-color-secondary);
  color: var(--text-color-primary);
  text-decoration: none;
  border: 1px solid var(--text-color-secondary);
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
}

.back-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 6px;
  background: var(--background-color-secondary);
  color: var(--text-color-primary);
  text-decoration: none;
  border: 1px solid var(--text-color-secondary);
}

.back-button .back-label {
  font-size: 14px;
  font-weight: 500;
}

.back-button svg {
  width: 16px;
  height: 16px;
  fill: currentColor;
}

.header-actions {
  display: flex;
  gap: 15px;
  align-items: center;
}

.sub-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-color-primary);
}

/* فرم تنظیمات */
.settings-form {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.form-section {
  border: 1px solid var(--text-color-secondary);
  border-radius: 8px;
  padding: 20px;
  background-color: var(--background-color-secondary);
  text-align: right;
  direction: rtl;
}

.form-section h3 {
  margin: 0 0 20px 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-color-primary);
  border-bottom: 1px solid var(--text-color-secondary);
  padding-bottom: 10px;
}

.form-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: flex-end;
  direction: rtl;
}

/* Modal for deleting appointment tables */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  padding: 20px;
  animation: fadeIn 140ms ease-out;
}
.modal-box {
  background: var(--background-color);
  color: var(--text-color-primary);
  border-radius: 10px;
  padding: 18px;
  width: 100%;
  max-width: 640px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.28);
  direction: rtl;
  text-align: right;
  transform: translateY(-6px);
  transition: transform 160ms ease, opacity 160ms ease;
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}
.modal-close {
  background: transparent;
  border: none;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  color: var(--text-color-secondary);
  padding: 6px 8px;
  border-radius: 6px;
}
.modal-close:hover {
  background: var(--background-color-secondary);
}
.modal-warning {
  background: #fff4f4;
  color: #8a1f1f;
  border: 1px solid rgba(138,31,31,0.08);
  padding: 10px 12px;
  border-radius: 6px;
  margin: 12px 0;
  font-weight: 600;
  font-size: 13px;
}
.modal-body .form-group {
  margin-bottom: 12px;
}
.modal-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 16px;
}
.btn-delete-confirm {
  padding: 10px 18px;
  font-weight: 700;
}

@media (max-width: 600px) {
  .modal-box { max-width: 96%; padding: 14px; }
  .modal-grid { grid-template-columns: 1fr; }
  .modal-actions { flex-direction: column-reverse; }
  .modal-actions .btn { width: 100%; }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Slightly round the internal date-picker container and input to match app aesthetics */
.p-date {
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: start;
  overflow: hidden;
  background-color: var(--background-color);
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.p-date :deep(.vpd-container) {
  border: 1px solid rgba(var(--text-color-secondary-rgb), 0.12);
  border-radius: 0.75rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  background-color: var(--background-color);
}

.p-date :deep(.vpd-input-group label) {
  background-color: var(--background-color-button) !important;
}

.p-date :deep(.vpd-input-group input) {
  border: none !important;
  line-height: 32px !important;
  background-color: var(--background-color) !important;
  color: var(--text-color-primary) !important;
}

.p-date :deep(.vpd-input-group input::placeholder) {
  color: var(--text-color-secondary) !important;
  opacity: 1;
}

.p-date :deep(.vpd-input-group input:focus) {
  border: 1px solid transparent !important;
}

.p-date :deep(.vpd-icon-btn),
.p-date :deep(button.vpd-icon-btn),
.p-date :deep(.vpd-actions button) {
  background-color: var(--background-color-button) !important;
  color: var(--background-color) !important;
  transition: background-color 0.3s ease !important;
}

.p-date :deep(.vpd-icon-btn svg),
.p-date :deep(button.vpd-icon-btn svg),
.p-date :deep(.vpd-actions button svg),
.p-date :deep(.vpd-icon-btn svg path),
.p-date :deep(button.vpd-icon-btn svg path),
.p-date :deep(.vpd-actions button svg path) {
  fill: var(--background-color) !important;
  color: var(--background-color) !important;
  stroke: var(--background-color) !important;
}

.p-date :deep(.vpd-icon-btn:hover),
.p-date :deep(button.vpd-icon-btn:hover),
.p-date :deep(.vpd-actions button:hover) {
  background-color: var(--background-color-button-hover) !important;
}

.form-row {
  display: flex;
  gap: 20px;
  flex: 1;
  min-width: 500px;
}

/* Ensure select groups inside a form-row share the row equally (1/2 - 1/2)
   while allowing them to shrink properly to avoid overflow. Mobile rules
   (seen later) will make them full-width. */
.form-row .select-narrow {
  min-width: 0; /* allow shrinking inside flex container */
  flex: 1 1 calc(50% - 10px);
  max-width: calc(50% - 10px);
}



.form-group {
  display: flex;
  flex-direction: column;
  direction: rtl;
  min-width: 250px;
  flex: 1;
}

.form-group-spaced {
  margin-top: 20px;
  margin-right: 20px;
}

.narrow-checkbox {
  max-width: 80px;
  flex: none;
}

/* remove right margin for the online booking checkbox container in RTL layout */
.online-booking {
  margin-right: 0;
}

.form-group-margin-top {
  margin-top: 20px;
}

.form-group label {
  margin-bottom: 8px;
  color: var(--text-color-primary);
  font-weight: 500;
  text-align: right;
  align-self: flex-end;
  width: 100%;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 10px 12px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 6px;
  text-align: right;
  direction: rtl;
  width: 100%;
  font-size: 14px;
  transition: border-color 0.15s ease-in-out;
  background-color: var(--background-color);
  color: var(--text-color-primary);
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--text-color-primary);
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: flex-start;
  direction: rtl;
}



.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-weight: 500;
  color: var(--text-color-primary);
  direction: rtl;
  justify-content: flex-start;
}

/* Right-align the specific receipt-content checkboxes (logo/date/time/receipt number) */
.checkbox-right {
  align-items: flex-end;
  /* move items to the right in RTL */
}

.checkbox-right .checkbox-label {
  display: flex;
  flex-direction: row-reverse;
  /* put checkbox on the right and label on the left */
  justify-content: flex-end;
  /* place checkbox and label to the right */
  width: 100%;
  text-align: right;
}

.checkbox-right .checkbox-label input[type="checkbox"] {
  /* ensure spacing between checkbox (right) and text (left) */
  margin-left: 8px;
  margin-right: 0;
}

/* Right-to-left alignment helper for the appointment settings section */
.form-section.rtl {
  direction: rtl;
  text-align: right;
}
.form-section.rtl .radio-group {
  display: flex;
  justify-content: flex-end; /* place radio options starting from the right */
  gap: 12px;
  align-items: center;
  width: 100%;
}
.form-section.rtl .radio-label {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-direction: row; /* text first, radio on the right */
  justify-content: flex-end;
  /* let labels grow so their text has more space; radios remain small */
  flex: 1 1 0;
  min-width: 0; /* allow flex children to shrink properly */
}
.form-section.rtl .radio-label .radio-text {
  /* text area takes most of the label width */
  flex: 1 1 auto;
  text-align: right;
  white-space: normal;
  overflow: hidden;
}
.form-section.rtl .radio-label input[type="radio"] {
  /* keep radio control small and aligned at the right */
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  margin-left: 0;
}

.checkbox-label input[type="checkbox"] {
  width: auto;
  margin: 0;
}

.checkbox-label input[type="number"] {
  width: 90px;
  padding: 6px 8px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 6px;
  text-align: center;
  background-color: var(--background-color);
  color: var(--text-color-primary);
}

.delete-buttons-container {
  display: flex;
  gap: 20px;
  justify-content: flex-start;
  direction: rtl;
  flex-wrap: wrap;
  align-items: center;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  padding-top: 20px;
  border-top: 1px solid var(--text-color-secondary);
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
}

.btn-primary {
  background-color: var(--background-color-button);
  color: var(--text-color-button);
}

.btn-primary:hover {
  background-color: var(--background-color-button-hover);
}

.btn-secondary {
  background-color: var(--background-color-secondary);
  color: var(--text-color-secondary);
}

.btn-secondary:hover {
  background-color: var(--background-color-secondary-hover);
}

.btn-danger {
  background-color: var(--background-color-danger);
  color: var(--text-color-danger);
}

.btn-danger:hover {
  background-color: var(--background-color-danger-hover);
}

.input-with-button {
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
}

.input-with-button select {
  flex: 1;
}

.input-with-button .btn {
  flex-shrink: 0;
  white-space: nowrap;
  padding: 8px 12px;
  font-size: 12px;
}

/* رسپانسیو */
@media (max-width: 768px) {
  .settings-tabs {
    justify-content: flex-end;
  }

  .tab-button {
    font-size: 12px;
    padding: 10px 15px;
  }

  /* stack form grid to a single column on small screens */
  .form-grid {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  /* make rows stack and remove forced min-widths that cause overflow */
  .form-row {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
    /* allow to shrink inside container */
  }

  /* keep labels and controls right-aligned in RTL on mobile like the "نام مطب" field */
  .form-group {
    align-items: flex-end;
    text-align: right;
    width: 100%;
    min-width: 0;
  }

  /* ensure inputs/selects/textarea fit the container and don't overflow */
  .form-group input,
  .form-group select,
  .form-group textarea {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  /* checkbox groups should also align to the right on small screens */
  .checkbox-group {
    align-items: flex-end;
    width: 100%;
  }

  /* narrow checkboxes can expand to full width so labels don't wrap oddly */
  .narrow-checkbox {
    max-width: 100%;
    flex: none;
  }

  /* set explicit target width for the two select fields (mobile) */
  /* wrapper class for those two selects so the entire form-group can be aligned */
  /* make the select groups behave like other full-width inputs (e.g. clinic-name)
     so their right edges line up with other fields */
  /* make select groups identical to other .form-group inputs (full width, stretched)
     so they line up exactly with fields like #clinic-name */
  .select-narrow {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    align-self: stretch;
  }

  .select-narrow>select {
    width: 100%;
    box-sizing: border-box;
    text-align: right;
    direction: rtl;
    /* ensure select control and its native arrow/layout are RTL */
  }

  /* Remove native arrow and add a consistent custom arrow so selects
     visually match text inputs and their inner padding/edge alignment */
  .select-narrow>select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    /* small down-arrow SVG, dark color adjustable */
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='12' height='12'><polyline points='6 9 12 15 18 9' fill='none' stroke='%23333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg>");
    background-repeat: no-repeat;
    /* place arrow near the visual left inside the control (matches input left padding) */
    background-position: left 12px center;
    background-size: 12px;
    /* keep text aligned to the right but make room on left for the custom arrow */
    padding: 10px 12px 10px 40px;
    /* top right bottom left */
  }

  /* Mobile-only: make all checkbox controls align to the right like other fields.
     This targets only checkboxes inside .checkbox-group on small screens. */
  .checkbox-group .checkbox-label {
    flex-direction: row-reverse;
    /* place checkbox at the right edge */
    justify-content: flex-end;
    /* push items to the right */
    text-align: right;
    width: 100%;
  }

  .checkbox-group .checkbox-label input[type="checkbox"] {
    /* keep the checkbox visually separated from the label text */
    margin-left: 8px;
    /* spacing between checkbox (right) and text (left) */
    margin-right: 0;
  }
}
</style>

<style scoped>
/* spacing for page header */
.view-container>.header {
  margin-top: 20px;
  margin-bottom: 0;
  text-align: right !important;
  width: 100% !important;
  direction: rtl;
  display: flex !important;
  align-items: center;
  gap: 6px;
}

.view-container>.header .info-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  /* place a small gap between text and icon: icon sits to the right of the text */
  margin-left: 4px;
  margin-right: 0;
  position: relative; /* enable z-index */
  z-index: 2; /* ensure icon sits above text */
}

.view-container>.header .header-text {
  position: relative;
  z-index: 1;
  /* Ensure the header text is right-aligned in RTL layout */
  text-align: right;
  direction: rtl;
}

/* Make order explicit to avoid external stylesheet collisions */
.view-container>.header .header-text { order: 1; }
.view-container>.header .info-icon { order: 2; }
</style>